import { array, object, string } from 'yup'

export const difficultRouteSchema = object().shape({
  directions: array().of(
    object().shape({
      from: object()
        .shape({
          cityName: string().required(),
          cityIataCode: string().required(),
        })
        .required(),

      to: object()
        .shape({
          cityName: string().required(),
          cityIataCode: string().required(),
        })
        .required(),

      date: string().required(),

      back_date: string().notRequired().nullable(),
    }),
  ),
})
